module.exports = __webpack_public_path__ + "img/plan2-max.a7fae257.jpg";